import React from "react";
import { Product } from "../interfaces/home_entity";
import ProductCard from "../components/ProductCard";

interface FeaturedProductsProps {
  products: Product[];
  visibleCount: number;
  showMore: () => void;
}

const FeaturedProducts: React.FC<FeaturedProductsProps> = ({ products, visibleCount, showMore }) => (
  <section className="featured-section">
    <h2>Featured Products</h2>
    <div className="product-grid">
      {products.slice(0, visibleCount).map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
    {visibleCount < products.length && (
      <div className="show-more-container">
        <button className="show-more-btn" onClick={showMore}>Show More</button>
      </div>
    )}
  </section>
);

export default FeaturedProducts;
